module.exports = __webpack_public_path__ + "img/32.4b60c762.png";